export default __webpack_public_path__ + "assets/observatories-4.fa0a18a7.jpg";